import { get, post, upload, del } from '../request.js'

// 步骤推进
export const pushRequirement = (params) => post('/requirement/pushRequirement', params)

// 步骤回退
export const rollbackRequirement = (params) => post('/requirement/rollbackRequirement', params)

// 上传附件
export const uploadAttachment = (params, query = '', progress) => upload(`/requirement/uploadFile${query}`, params, progress)

// 下载附件
export const downAttachment = (params) => post('/requirement/downFile', params, false, true)

// 查询列表
export const findRequirementCardList = (params) => post('/requirement/findRequirementCardList', params, true)

// 删除需求
export const deleteRequirement = (params) => del('/requirement/deleteRequirement', params)

// 需求开发 -> 回显信息
export const findRequirementDetail = (params) => get('/requirement/findRequirementDetail', params)

// 需求开发 -> 新增
export const addRequirement = (params) => post('/requirement/addRequirement', params, true)

// 需求开发 -> 编辑
export const updateRequirement = (params) => post('/requirement/updateRequirement', params, true)

// 会议评估 -> 查询会议列表
export const findRequirementMeetingList = (params) => get('/requirementMeeting/findRequirementMeetingList', params)

// 会议评估 -> 新增
export const addRequirementMeeting = (params) => post('/requirementMeeting/addRequirementMeeting', params, true)

// 会议评估 -> 编辑
export const updateRequirementMeeting = (params) => post('/requirementMeeting/updateRequirementMeeting', params, true)

// 会议评估 -> 删除
export const deleteRequirementMeeting = (params) => del('/requirementMeeting/deleteRequirementMeeting', params)

// 会议评估 -> 不同意
export const refuseRequirement = (params) => post('/requirement/refuseRequirement', params)

// 功能开发 -> 查询
export const findRequirementDevelop = (params) => get('/requirementDevelop/findRequirementDevelop', params)

// 功能开发 -> 新增
export const addRequirementDevelop = (params) => post('/requirementDevelop/addRequirementDevelop', params, true)

// 功能开发 -> 编辑
export const updateRequirementDevelop = (params) => post('/requirementDevelop/updateRequirementDevelop', params, true)

// 销售评价 -> 查询
export const findRequirementEvaluation = (params) => get('/requirementEvaluation/findRequirementEvaluation', params)

// 销售评价 -> 新增
export const addRequirementEvaluation = (params) => post('/requirementEvaluation/addRequirementEvaluation', params, true)

// 销售评价 -> 编辑
export const updateRequirementEvaluation = (params) => post('/requirementEvaluation/updateRequirementEvaluation', params, true)